import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'slotcom-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class IconComponent {
  @Input() classes: Array<string> = [];
}
